type Props = {
    width?:number;
    height?:number;
    fill?:string;
}

const EmailIcon = ({
    width =12,
    height=12,
    fill
}: Props) =>{
    return (
       <svg width={width} height={height} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11 3.5L6.5045 6.3635C6.35195 6.45211 6.17867 6.49878 6.00225 6.49878C5.82583 6.49878 5.65255 6.45211 5.5 6.3635L1 3.5" stroke="#5D6E69" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M10 2H2C1.44772 2 1 2.44772 1 3V9C1 9.55228 1.44772 10 2 10H10C10.5523 10 11 9.55228 11 9V3C11 2.44772 10.5523 2 10 2Z" stroke="#5D6E69" strokeLinecap="round" strokeLinejoin="round"/>
</svg>



    )
}

export default EmailIcon;